<template>
  <div>
    <article-editor :article="blankArticle" ref="editor"></article-editor>
  </div>
</template>
<style>

</style>

<script>

import Vue from "vue";
import articleEditor from "../common/articleEditor";

export default {
  components: {
    articleEditor
  },
  data: function() {
    return {
      blankArticle: {
        layout: "article-layout-default",
        title: "",
        content: "",
        name: "",
        tags: [],
        widgets: [],
        type: "post",
        seoPhrase: "",
        status: "draft",
        timestamp: Math.floor(Date.now()/1000),
        slug: "",
        meta: {
          title: "",
          description: ""
        }
      }
    }
  },
  mounted: function() {
    this.$refs['editor'].initialiseArticle();
  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// createArticle.vue?3275b922